module.exports = "/img/2.85d2d6.webp";